import { render, staticRenderFns } from "./SmsPlatform.vue?vue&type=template&id=89f2ff10&"
import script from "./SmsPlatform.vue?vue&type=script&lang=js&"
export * from "./SmsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./SmsPlatform.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports